import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ThankForSharing = lazyWithPreload(
  () => import('./ThankForSharing'),
)
